import React, { useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const Menu = ({
  children,
  isOpen,
  widthClass,
  value,
  onChange,
  close,
  align,
  onClose,
  shadowClass,
  alignClass,
}) => {
  const handleItemClick = (val) => {
    onChange(val);
    close();
  };

  useEffect(() => {
    if (!isOpen) {
      onClose();
    }
  }, [isOpen, onClose]);

  return (
    isOpen && (
      <div
        className={clsx(
          widthClass || 'w-full',
          alignClass || (align === 'left' ? 'left-0' : 'right-0'),
          'origin-top-right absolute  mt-2 rounded-2xl shadow-lg z-20',
        )}
      >
        <div className={clsx('rounded-2xl bg-fields-0', shadowClass)}>
          <div
            className="py-1"
            role="menu"
            aria-orientation="vertical"
            aria-labelledby="options-menu"
          >
            {React.Children.map(children, (child) => {
              // skip empty children (e.g. conditionally rendered items like `{headerContent && <Dropdown.Item>...}`)
              if (!child || !child.props) return child;
              const p = {
                onClick: child.props.variant === 'select' ? handleItemClick : child.props.onClick,
                checked: value >= 0 && child.props.value === value,
              };
              return React.cloneElement(child, p);
            })}
          </div>
        </div>
      </div>
    )
  );
};

Menu.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  isOpen: PropTypes.bool,
  widthClass: PropTypes.string,
  value: PropTypes.number,
  onChange: PropTypes.func,
  close: PropTypes.func,
  align: PropTypes.string,
  shadowClass: PropTypes.string,
  onClose: PropTypes.func,
  alignClass: PropTypes.string,
};

Menu.defaultProps = {
  isOpen: false,
  widthClass: undefined,
  value: undefined,
  onChange: undefined,
  close: undefined,
  align: undefined,
  shadowClass: 'shadow-xs',
  onClose: () => {},
  alignClass: undefined,
};

export default Menu;
